export const englishUnits = {
  pieces: 'pcs',
  dollar: 'Dollar',
  percentage: 'Percentage',
  orders: 'ord',
  packs: 'pack',
  liter: 'L',
  kilograms: 'Kg',
  tonnes: 't',
  pounds: 'lb',
  cubic_meter: 'm³',
  gallon: 'gal',
  acre: 'ac',
  kilowatt_hour: 'kWh',
  square_meter: 'm²',
  gigabyte: 'GB',
  hours: 'hrs',
  barrel: 'bbl',
  units: 'units',
  feet: 'ft',
  square_feet: 'ft²',
  cubic_feet: 'ft³',
  ounces: 'oz',
  miles: 'M',
} as const;

export const getEnglishUnit = (unit: string | undefined) => {
  if (!unit) return '';
  if (unit in englishUnits) {
    return englishUnits[unit as keyof typeof englishUnits];
  }
  return '';
};
